class ProductCarouselSwiper extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.js-product-carousel-swiper')
    const scrollbarEl = this.querySelector('.js-product-carousel-scrollbar')
    const option = {
      init: false,
      spaceBetween: 15,
      slidesPerView: 1.5,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 15,
      slidesOffsetBefore: 15,
      slidesPerGroup: 1,
      scrollbar: {
        el: scrollbarEl,
        enabled: true,
        draggable: true,
        snapOnRelease: true,
        dragSize: 'auto',
      },
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        enabled: true,
        sensitivity: 4,
        releaseOnEdges: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2.5,
          slidesOffsetAfter: 28,
          slidesOffsetBefore: 28,
        },
        990: {
          slidesPerView: 3.4,
          spaceBetween: 22,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
        },
        1400: {
          slidesPerView: 3.9,
          spaceBetween: 22,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
        },
        1800: {
          slidesPerView: 4.5,
          spaceBetween: 22,
          slidesOffsetAfter: 60,
          slidesOffsetBefore: 60,
        },
      },
    }

    this.$swiper = new Swiper(swiperEl, option)
    this.$swiper.init()
    this.$swiper.enable()
  }

  disconnectedCallback() {
    if (this.$swiper && typeof this.$swiper.destroy === 'function') {
      this.$swiper.destroy(true, true)
    }
  }
}

if (!customElements.get('product-carousel-swiper')) {
  customElements.define('product-carousel-swiper', ProductCarouselSwiper);
}
